var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smy__box"},[_c('div',{staticClass:"smy__left"},[_c('SecondMenu')],1),_vm._v(" "),_c('div',{staticClass:"smy__right"},[_c('HeadNav'),_vm._v(" "),_c('HeadTags'),_vm._v(" "),_c('div',{staticClass:"smy__content"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"router"})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8f3c15","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 